/* SpawnAnything — daily battle leaderboard client (/api/daily, see src/game/dailyRules.js). Network errors resolve to
   null: the battle itself never depends on the board. */
const get = async (url, opt) => {
  try {
    const ctrl = new AbortController(), t = setTimeout(() => ctrl.abort(), 8000);
    const res = await fetch(url, { ...opt, signal: ctrl.signal }); clearTimeout(t);
    const data = await res.json().catch(() => null);
    return res.ok && data && typeof data === 'object' ? data : (data && data.error ? { error: data.error } : null);
  } catch { return null; }
};
/** { day, top: [{ n, s, a }] } or null */
export const fetchBoard = day => get('/api/daily?day=' + encodeURIComponent(day));
/** { day, rank, top } or { error } or null */
export const submitScore = entry => get('/api/daily', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(entry) });
